import CellValue from '@app/shared/components/cell-value/CellValue';
import { amountRules } from '@app/shared/components/cell-value/CellValueConfigurations';
import {
  FirstLastInstrumentTransactionSummary,
  FirstLastSummaryIndexDictionaryDto,
  OpmFirstLastWaterfallDictionaryDto,
} from '@app/shared/models/contracts/opm-calculation-results-dto';
import { l, translationKeys } from '@locale/setupI18n';
import classNames from 'classnames';
import styles from '@app/modules/projects/outputs/opm-summary-waterfall/opm-summary-waterfall-erf.module.scss';
import { simulationSectionsDefinition } from '../../helper/FirstLastHelpers';

interface TransactionSummaryRowProps {
  label: translationKeys;
  valueKey: keyof FirstLastInstrumentTransactionSummary;
  opmWaterfall: OpmFirstLastWaterfallDictionaryDto;
  selectedInstrument: string;
  selectedYear: string;
  waterfallIterations: number;
  isBold?: boolean;
  invertSign?: boolean;
}

const TransactionSummaryRow: React.FC<TransactionSummaryRowProps> = ({
  label,
  valueKey,
  opmWaterfall,
  selectedInstrument,
  selectedYear,
  waterfallIterations,
  isBold = false,
  invertSign = false,
}: TransactionSummaryRowProps) => {
  const hasValue = simulationSectionsDefinition.some((section) =>
    Object.entries(opmWaterfall[selectedYear][section]).some(
      ([key, _]) =>
        (opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto)[key]
          .instruments[selectedInstrument].transactionSummary &&
        typeof (
          (opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto)[key]
            .instruments[selectedInstrument]
            .transactionSummary as FirstLastInstrumentTransactionSummary
        )[valueKey] === 'number'
    )
  );
  if (!hasValue) {
    return null;
  }

  return (
    <tr>
      <td
        className={classNames(styles['border-right'], { [styles['bold-text']]: isBold })}
        data-testid={`${valueKey}-instrument-title`}>
        {l(label)}
      </td>
      {simulationSectionsDefinition.map((section, outerIndex) =>
        Object.entries(opmWaterfall[selectedYear][section]).map(([key, _], innerIndex) => {
          const transactionSummary = (
            opmWaterfall[selectedYear][section] as FirstLastSummaryIndexDictionaryDto
          )[key].instruments[selectedInstrument].transactionSummary;
          let value = transactionSummary ? transactionSummary[valueKey] : undefined;
          if (invertSign && typeof value === 'number') {
            value = -value;
          }
          return (
            <td
              key={`${section}-${key}`}
              className={classNames({
                [styles['border-right']]:
                  outerIndex === 0 && innerIndex + 1 === waterfallIterations,
              })}
              data-testid={`${valueKey}-instrument-simulation-${key}`}>
              <CellValue value={value} {...amountRules} />
            </td>
          );
        })
      )}
    </tr>
  );
};

export default TransactionSummaryRow;
